"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var overrideValues = {};

var set = function set(name, value) {
  overrideValues[name] = value;
};

var get = function get(name) {
  return overrideValues[name];
};

var _default = {
  set: set,
  get: get
};
exports["default"] = _default;